import { Theme } from '@mui/material/styles';

// ----------------------------------------------------------------------

export default function LoadingButton(theme: Theme) {
  return {
    MuiLoadingButton: {
      styleOverrides: {
        root: {
          // '&:hover': {
          //   backgroundColor: theme.palette.actionBlue.hover,
          // },
          '&.MuiButton-text': {
            '& .MuiLoadingButton-startIconPendingStart': {
              marginLeft: 0
            },
            '& .MuiLoadingButton-endIconPendingEnd': {
              marginRight: 0
            }
          }
        },
        primary: {
          boxShadow: 'none',
          color: theme.palette.buttonPrimary.text,
          border: `1px solid ${theme.palette.buttonPrimary.background}`,
          backgroundColor: theme.palette.buttonPrimary.background,
          '&:hover': {
            color: theme.palette.buttonPrimary.text,
            border: theme.palette.actionBlue.hover,
            backgroundColor: theme.palette.actionBlue.hover,
          },
          '&.Mui-disabled': {
            color: theme.palette.buttonPrimary.text,
            border: theme.palette.actionBlue.disabled,
            backgroundColor: theme.palette.actionBlue.disabled,
          }
        },
        secondary: {
          boxShadow: 'none',
          color: theme.palette.buttonSecondary.text,
          border: `1px solid ${theme.palette.buttonSecondary.stroke}`,
          backgroundColor: theme.palette.buttonSecondary.background,
          '&:hover': {
            color: theme.palette.actionBlue.hover,
            border: `1px solid ${theme.palette.actionBlue.hover}`,
            backgroundColor: theme.palette.buttonSecondary.background,
          },
          '&.Mui-disabled': {
            color: theme.palette.action.disabled,
            border: `1px solid ${theme.palette.action.disabled}`,
            backgroundColor: theme.palette.buttonSecondary.background
          }
        },
        tertiary: {
          boxShadow: 'none',
          color: theme.palette.buttonTertiary.text,
          border: `1px solid ${theme.palette.buttonTertiary.background}`,
          backgroundColor: theme.palette.buttonTertiary.background,
          '&:hover': {
            color: theme.palette.buttonTertiary.text,
            border: `1px solid ${theme.palette.actionPurple.hover}`,
            backgroundColor: theme.palette.actionPurple.hover,
          },
          '&.Mui-disabled': {
            color: theme.palette.buttonPrimary.text,
            border: `1px solid ${theme.palette.actionPurple.disabled}`,
            backgroundColor: theme.palette.actionPurple.disabled,
          }
        },
      }
    }
  };
}
